import React, { Component } from 'react';
import Icon from 'components/common/Icon';

class Collapsable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.defaultOpen,
    };
  }

  render() {
    const { iconName, title, content } = this.props;
    const disclosureClass = this.state.open ? 'rotate-90 disclosure' : 'disclosure';
    const toggle = () => {
      this.setState({ open: !this.state.open });
    };

    return (
      <div className="flex-container">
        <div className="flex-item-fixed-30">
          <Icon size="large" icon={iconName} onClick={toggle} className="clickable" />
        </div>
        <div className="flex-item-fill">
          <h4 onClick={toggle} className="clickable">
            {title}
            <Icon icon="arrow" className={disclosureClass} size="small" />
          </h4>
          {this.state.open && content}
        </div>
      </div>
    );
  }
}

export default Collapsable;



// WEBPACK FOOTER //
// ./src/app/components/calendar/Collapsable.js